'use strict';

import axios from 'axios';
import { toggleClassToElement, classes } from '../partials/class-list-utils';
import Modal from '@jsclasses/modal-class';

const DONATION_INCLUDE_CLASSNAME = 'js-donation_include';
const DONATION_CHECK_CLASSNAME = 'js-cart__donation-checkbox';
const DONATION_ONG_CLASSNAME = 'js-donation_ong';
const DONATION_STATE_MSG = 'js-donation__state-msg';
const CART_ITEM_LIST_CLASSNAME = 'js-cart__list';

const DONATION_INCLUDE_SELECTOR = `.${DONATION_INCLUDE_CLASSNAME}`;
const DONATION_CHECK_SELECTOR = `.${DONATION_CHECK_CLASSNAME}`;
const DONATION_ONG_SELECTOR = `.${DONATION_ONG_CLASSNAME}`;
const DONATION_STATE_SELECTOR = `.${DONATION_STATE_MSG}`;
const CART_ITEM_LIST_SELECTOR = `.${CART_ITEM_LIST_CLASSNAME}`;

const donationInclude = document.querySelector(DONATION_INCLUDE_SELECTOR);
const cartActionProcessing = new CustomEvent('cartActionProcessing');

function updateCheckboxState() {
  const cartList = document.querySelector(CART_ITEM_LIST_SELECTOR);
  const donationChecks = document.querySelectorAll(DONATION_CHECK_SELECTOR);

  donationChecks.forEach((check) => {
    const checkId = check.dataset.pid;
    const product = cartList.querySelector('[data-pid="' + checkId + '"]');

    check.checked = product ? true : false;
  });
}

function toggleOpenState(ong) {
  toggleClassToElement(ong, classes.is.visible);
}

function initNgoActions() {
  const donationOngs = document.querySelectorAll(DONATION_ONG_SELECTOR);

  donationOngs.forEach((ong) =>
    ong.addEventListener('click', (event) => {
      toggleOpenState(ong);
    })
  );
}

function initCheckboxActions() {
  const donationChecks = document.querySelectorAll(DONATION_CHECK_SELECTOR);
  if (donationChecks) {
    donationChecks.forEach((check) => {
      check.addEventListener('change', (event) => {
        const cartProductRow = document.querySelector(CART_ITEM_LIST_SELECTOR);
        var checkboxId = event.currentTarget.dataset.pid;
        var productUUID = '';
        var lineItem = cartProductRow.querySelector(
          '[data-pid="' + checkboxId + '"]'
        );

        if (lineItem) {
          productUUID = lineItem.dataset.uuid;
        }
        if (event.currentTarget.checked && !lineItem) {
          addDonationToCart(event.currentTarget, checkboxId);
        } else if (!event.currentTarget.checked && lineItem) {
          removeDonationFromCart(event.currentTarget, checkboxId, productUUID);
        }
      });
    });
  }
}

function addDonationToCart(checkbox, itemPID) {
  const isCartFull = document.querySelector('.js-cart').dataset.full;
  if (isCartFull === 'true') {
    checkbox.checked = false;
  } else {
    checkbox.disabled = true;
    document.dispatchEvent(cartActionProcessing);
  }
  document.dispatchEvent(
    new CustomEvent('addDonationToCart', {
      detail: {
        itemPID: itemPID
      }
    })
  );
}

function removeDonationFromCart(checkbox, itemPID, itemUUID) {
  checkbox.disabled = true;
  const cartWrapper = document.querySelector('.js-cart');
  document.dispatchEvent(
    new CustomEvent('removeDonationFromCart', {
      detail: {
        itemPID: itemPID,
        itemUUID: itemUUID,
        target: checkbox,
        wrapper: cartWrapper
      }
    })
  );
}

function initDonations() {
  var urlDonationsShow = donationInclude.dataset.url;

  axios
    .post(urlDonationsShow)
    .then(function (response) {
      if (
        response.data.ngosRender &&
        response.data.ngosRender.trim() !== '' &&
        response.data.success === true
      ) {
        donationInclude.innerHTML = response.data.ngosRender;
        initCheckboxActions();
        initNgoActions();
        updateCheckboxState();
        Modal.initElements('donations'); // Starts modals components
      } else {
        donationInclude.remove();
      }
    })
    .catch(function (error) {
      console.log(error);
      donationInclude.remove();
    });
}

document.addEventListener('DOMContentLoaded', function () {
  if (donationInclude) {
    var urlDonationsShow = donationInclude.dataset.url;

    if (urlDonationsShow) {
      initDonations();
    }

    document.addEventListener('updateDonationsFromCart', () => {
      updateCheckboxState();
    });

    document.addEventListener('donations:afterAddToCart', (e) => {
      const donationChecks = document.querySelectorAll(DONATION_CHECK_SELECTOR);

      donationChecks.forEach((check) => {
        if (check.dataset.pid === e.detail.checkboxID) {
          check.disabled = false;
        }
      });
    });
  }
});
